import en from '../translations/en-CA';
import fr from '../translations/fr-CA';
import { Language } from '../typings/Language';

export const getKeyFromTranslatedPath = (locale: Language, key: string) => {
  const dict = locale === 'en' ? en : fr;
  return Object.entries(dict.paths).find((entry) => entry[1] === key)?.[0];
};
